import request from 'request/index'
import { E_PRODUCT2_RES, E_PRODUCT3_RES } from 'utils/config'
export default {
  /**
   *  2.3.1.1 创建评论[post] /c/app/{app_id}/comment
   */
  sAddComment ({
    app_id,
    content,
    more_pic_dentryid,
    px = 1,
    py = 1,
    ph = 1,
    pv = 1,
    grade
  }) {
    return request({
      method: 'POST',
      res: E_PRODUCT2_RES,
      api: '/c/app/{app_id}/comment',
      params: {
        app_id
      },
      body: {
        content,
        more_pic_dentryid,
        grade,
        ph,
        pv,
        py,
        px
      }
    })
  },
  /**
   *  2.3.1.2 修改评论[put] /c/app/{app_id}/comment/{comment_id}
   */
  sModifyComment ({
    app_id,
    comment_id,
    content,
    grade,
    more_pic_dentryid
  }) {
    return request({
      method: 'PUT',
      res: E_PRODUCT2_RES,
      api: '/c/app/{app_id}/comment/{comment_id}',
      params: {
        app_id,
        comment_id
      },
      body: {
        content,
        grade,
        more_pic_dentryid
      }
    })
  },
  /**
   *  2.3.1.3 获取评论列表[get] v0.3/c/app/{app_id}/comment?$count=true&max_comment_id=1&$limit=数量 ( 这个请用 v0.3)
   */
  sGetCommentList ({
    $count = true,
    app_id,
    max_comment_id = 99999999,
    $limit = 10,
    $offset = 0,
    grades
  }) {
    return request({
      method: 'GET',
      res: E_PRODUCT3_RES,
      api: '/visitor/app/{app_id}/comment',
      params: {
        app_id
      },
      query: {
        max_comment_id,
        $limit,
        grades,
        $count,
        $offset
      }
    })
  },
  /**
   *  2.3.1.5 获取评论单个[get] /c/app/{app_id}/comment/{comment_id}
   */
  sGetCommentInfo (app_id, comment_id) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/c/app/{app_id}/comment/{comment_id}',
      params: {
        app_id,
        comment_id
      }
    })
  },
  /**
   *  2.3.1.6 删除评论[delete] /c/app/{app_id}/comment/{comment_id}
   */
  sDeleteComment (app_id, comment_id) {
    return request({
      method: 'DELETE',
      res: E_PRODUCT2_RES,
      api: '/c/app/{app_id}/comment/{comment_id}',
      params: {
        app_id,
        comment_id
      }
    })
  },
  /**
   *  2.3.1.4 获取评论星级数量[get] v0.3/c/app/{app_id}/comment/grade_count?grades=1,2 ( 这个请用 v0.3 )
   */
  sGetCommentCount (app_id, grades) {
    return request({
      method: 'GET',
      res: E_PRODUCT3_RES,
      api: '/visitor/app/{app_id}/comment/grade_count',
      params: {
        app_id
      },
      query: {
        grades
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/comment.js